import { useState } from 'react';
import { validateField, validateAllFields, cleanInput, hasErrors } from '../utils/validation';

export const useFormValidation = (initialValues, validationConfig = null) => {
  const [form, setForm] = useState(initialValues);
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});

  /**
   * Handle input change with validation
   */
  const handleChange = (e) => {
    const { name, value } = e.target;
     const trimmedValue = value.trimStart();
    // Clean input based on field type
    // const cleanedValue = cleanInput(name, trimmedValue);
    const cleanedValue = trimmedValue;
    // Update form state
    setForm((prev) => ({
      ...prev,
      [name]: cleanedValue,
    }));

    // Validate field if it's been touched
    if (touched[name]) {
      const customRule = validationConfig?.[name];
      const error = validateField(name, cleanedValue, customRule, { ...form, [name]: cleanedValue });
      setErrors((prev) => ({
        ...prev,
        [name]: error,
      }));
    }
  };

  /**
   * Handle blur event to mark field as touched
   */
  const handleBlur = (e) => {
    const { name, value } = e.target;
    
    setTouched((prev) => ({
      ...prev,
      [name]: true,
    }));

    // Validate on blur
    const customRule = validationConfig?.[name];
    const error = validateField(name, value, customRule, form);
    setErrors((prev) => ({
      ...prev,
      [name]: error,
    }));
  };

  /**
   * Validate all fields
   */
  const validateAll = () => {
    const newErrors = validateAllFields(form, validationConfig);
    setErrors(newErrors);
    
    // Mark all fields as touched
    const allTouched = Object.keys(form).reduce((acc, key) => {
      acc[key] = true;
      return acc;
    }, {});
    setTouched(allTouched);
    
    return !hasErrors(newErrors);
  };

  /**
   * Reset form to initial values
   */
  const resetForm = () => {
    setForm(initialValues);
    setErrors({});
    setTouched({});
  };

  /**
   * Set form values programmatically
   */
  const setFormValues = (values) => {
    setForm(values);
  };

  /**
   * Set a single field value
   */
  const setFieldValue = (name, value) => {
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  /**
   * Set a single field error
   */
  const setFieldError = (name, error) => {
    setErrors((prev) => ({
      ...prev,
      [name]: error,
    }));
  };

  return {
    form,
    errors,
    touched,
    handleChange,
    handleBlur,
    validateAll,
    resetForm,
    setFormValues,
    setFieldValue,
    setFieldError,
    isValid: !hasErrors(errors),
  };
};
